import { defineStore } from 'pinia'
import axios from 'axios'

export const useEmcRequestStore = defineStore('emcRequest', {
  state: () => ({
    emcDetail: null,
    disasterList: [],
    notificationCount: null,
    emcRequestDetail: null
  }),

  actions: {
    async postEmcRequest(payload) {
      try {
        const response = await axios.post('/emc-request', payload)
        if (response.status === 200 || response.status === 201) {
          // console.log('POST:', response.data)
          return response.data
        } else {
          throw new Error(`POST failed: ${response.statusText}`)
        }
      } catch (error) {
        console.error('postEmcRequest error:', error)
        throw error
      }
    },

    async getEmcRequestByPhone(phone, query = {}) {
      try {
        const response = await axios.get(`/emc-requests/${phone}`, { params: query })
        if (response.status === 200) {
          this.emcDetail = response.data
          // console.log('GET:', response.data)
          return response.data
        } else {
          throw new Error(`GET failed: ${response.statusText}`)
        }
      } catch (error) {
        console.error('getEmcRequestByPhone error:', error)
        throw error
      }
    },

    async getDisasterList() {
      try {
        const response = await axios.get('/disaster')
        if (response.status === 200) {
          this.disasterList = response.data.data
          // console.log('Disaster List:', this.disasterList)
          return this.disasterList
        } else {
          throw new Error(`GET disaster failed: ${response.statusText}`)
        }
      } catch (error) {
        console.error('getDisasterList error:', error)
        throw error
      }
    },

    async getEmcRequestByPhoneAndId(phone, id) {
      try {
        const response = await axios.get(`/emc-requests/${phone}/${id}`)
        if (response.status === 200) {
          // console.log('GET Detail by phone and id:', response.data)
          return response.data
        } else {
          throw new Error(`GET failed: ${response.statusText}`)
        }
      } catch (error) {
        console.error('getEmcRequestByPhoneAndId error:', error)
        throw error
      }
    },

    async updateEmcRequest(id, payload) {
      try {
        const response = await axios.post(`/emc-request/${id}`, payload)
        if (response.status === 200) {
          // console.log('POST:', response.data)
          return response
        } else {
          throw new Error(`POST failed: ${response.statusText}`)
        }
      } catch (error) {
        console.error('postEmcRequest error:', error)
        throw error
      }
    },

    async getEmcNotification(filter) {
      try {
        const response = await axios.get(`/emc-request-noti`, { params: filter, noLoader: true })
        if (response.status === 200) {
          this.notificationCount = response.data.data
          return response
        } else {
          throw new Error(`GET failed: ${response.statusText}`)
        }
      } catch (error) {
        console.error('getEmcRequestByPhone error:', error)
        throw error
      }
    },

    async getEmcReporterDetailById(id) {
      try {
        const response = await axios.get(`/emc-request/${id}`)
        if (response.status === 200) {
          this.emcRequestDetail = response.data.data
          return response.data.data
        } else {
          throw new Error(`GET failed: ${response.message}`)
        }
      } catch (error) {
        console.error('getEmcReporterDetailById error:', error)
        throw error
      }
    }
  }
})
